/**
 * Permiso que abre cada pantalla del portal (basta con tener uno de la lista).
 * Es la única fuente: la usan el guard de rutas y el filtro del menú lateral.
 * Una ruta que no aparece aquí es visible para cualquier usuario autenticado.
 *
 * La seguridad real está en el gateway (@RequirePermissions); esto solo evita
 * ofrecer pantallas que darían 403.
 */
export const ROUTE_PERMISSIONS: Record<string, string[]> = {
  'inicio': ['home:read'],
  'business': ['business:read'],
  'establishments': ['establishments:read'],
  'branch-profile': ['branch-profile:read'],
  'emission-points': ['emission-points:read'],
  'establishments/:establishmentId/emission-points': ['emission-points:read'],
  'roles': ['roles:read'],
  'certificados': ['certificates:read'],
  'certificates': ['certificates:read'],
  'products': ['products:read'],
  'categories-brands': ['categories:read', 'brands:read'],
  'inventory': ['stocks:read'],
  'transfers': ['transfers:read'],
  'kardex': ['kardex:read'],
  'customers': ['customers:read'],
  'suppliers': ['suppliers:read'],
  'purchase-invoices': ['purchase-invoices:read'],
  'purchase-invoices/new': ['purchase-invoices:create'],
  'purchase-invoices/:id/correct': ['purchase-invoices:correct'],
  'sri-inbox': ['sri-inbox:read'],
  'purchase-orders': ['purchase-orders:read'],
  'purchase-orders/new': ['purchase-orders:create'],
  'purchase-orders/:id/edit': ['purchase-orders:update'],
  'purchase-reports': ['purchase-reports:read'],
  'sales-reports': ['sales-reports:read'],
  'iva-settlements': ['iva-settlements:read'],
  'petty-cash': ['petty-cash:read'],
  'treasury': ['treasury:read'],
  'bank-accounts': ['bank-accounts:read'],
  'official-statements': ['accounting-reports:balance-general:read', 'accounting-reports:estado-resultados:read'],
  'settlements': ['settlements:read'],
  'retentions': ['retentions:read'],
  'purchase-credit-notes': ['settlement-credit-notes:read'],
  'purchase-debit-notes': ['purchase-debit-notes:read'],
  'payables': ['payables:read'],
  'supplier-advances': ['supplier-advances:read'],
  'ats': ['ats:read'],
  'sri-reconciliation': ['ats:reconcile'],
  'quotations': ['quotations:read'],
  'orders': ['orders:read'],
  'pos': ['pos:read'],
  'cash-shifts': ['cash-shifts:read'],
  'invoices': ['invoices:read'],
  'credit-notes': ['credit-notes:read'],
  'debit-notes': ['debit-notes:read'],
  'remission-guides': ['remission-guides:read'],
  'receivables': ['receivables:read'],
  'received-retentions': ['receivables:read'],
  'customer-advances': ['customer-advances:read'],
  'users': ['users:read'],
  'business-users': ['users:read'],
  'users/:userId/assignments': ['users:assignments:update'],
  'payment-methods': ['payment-methods:read'],
  'retention-codes': ['retention-preferences:update'],
  'receipt-config': ['receipt-config:read'],
  'ecommerce': ['ecommerce:read'],
  'chart-of-accounts': ['chart-of-accounts:read'],
  'account-mappings': ['account-mappings:read'],
  'accounting-entries': ['accounting-entries:read'],
  'accounting-reports': [
    'accounting-reports:diario:read',
    'accounting-reports:mayor:read',
    'accounting-reports:balance-comprobacion:read',
    'accounting-reports:estado-resultados:read',
    'accounting-reports:balance-general:read',
    'accounting-reports:situacion-inicial:read',
  ],
  'opening-balance': ['opening-balance:read'],
  'bank-reconciliations': ['bank-reconciliations:read'],
  'bank-reconciliations/:id': ['bank-reconciliations:read'],
  'fixed-assets': ['fixed-assets:read'],
  'period-end': ['accounting-reports:balance-general:read'],
  'accounting-periods': ['accounting-periods:read', 'accounting-entries:read'],
};

/** Ruta del menú (`/admin/x`) → permisos que la abren; `undefined` si no exige ninguno. */
export function permissionsForRoute(route: string): string[] | undefined {
  return ROUTE_PERMISSIONS[route.replace(/^\/admin\//, '').split('?')[0]];
}
